module.exports = __webpack_public_path__ + "img/icon-technology.f2c04556.png";